import { render, staticRenderFns } from "./ChangesHistory.vue?vue&type=template&id=174a0d46&scoped=true&"
import script from "./ChangesHistory.vue?vue&type=script&lang=js&"
export * from "./ChangesHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174a0d46",
  null
  
)

export default component.exports